import React from 'react';
import { Card, CardContent, Typography, Link } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import { AiFillDashboard } from "react-icons/ai";

const useStyles = makeStyles((theme) => ({
  card: {
    width: '100%',
    height: 'auto',
    backgroundColor: '#f0f0f0',
    borderRadius: "10px",
  },
  strip: {
    display: 'flex',
    // flexDirection: 'column',
    justifyContent: 'space-between',
    marginTop: '5px',
    flexWrap: 'wrap'
  },
outerBox: {
  padding: '23px 37px 30px 14px',
  position: 'relative',
  backgroundColor: '#fff',
  overflow: 'hidden',
  width: 'calc(25% - 10px)',
  margin: '5px',
  borderRadius: '5px',
  borderLeft: '4px solid #146694',
  display:'flex',
  alignItems:'center',

  '&::before': {
    content: '""',
    position: 'absolute',
    right: '-46px',
    width: '100px',
    height: '100px',
    background: 'linear-gradient(135deg, rgb(14 55 79 / 18%) 0%, rgb(21 108 156 / 30%) 100%)',
    borderRadius: '100%',
    bottom: '-48px',
  }
},

  cardItemHeading:{
   fontSize:'16px',
  },
  link:{
    fontSize:'14px',
    marginTop:'6px',
    display:'block',
    textDecoration:'none',
    color:'#12587f',
    fontWeight:'500',
     '&:hover': {
      fontSize: '14px', 
      color: '#1976d2',
    }
  },
  svgIcon:{
    fontSize:'26px',
    marginRight:'11px',
    color:'#125b83'
  }
  // link: {
  //   flex: 1,
  //   margin: '5px',
  //   width: '100%',
  //   textAlign: 'start',
  //   padding: '10px',
  //   backgroundColor: 'white',
  //   color: '#3498db',
  //   textDecoration: 'none',
  //   borderRadius: theme.spacing(0.5),
  //   position:'relative',
  //   overflow:'hidden'
  //   // marginRight: '10px',
  // },
  
}));

const Report = ({report, index}) => {
  const classes = useStyles();
  return (
    <Card className={classes.card}>
      <CardContent>
        <div className={classes.strip}>
          {report?.map((item, index) => (
            <div className={classes.outerBox}>
              <AiFillDashboard className={classes.svgIcon}/>
              <div>
                <h3 className={classes.cardItemHeading}>{item.label}</h3>
              <Link key={index} href={`${item.link}`} className={classes.link}>
               View Report
              </Link>
                </div>
              
              </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default Report;
